<template>
  <div>
    <label
      class="input__label"
      :for="id"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <input-textarea
      class="margin__t--6"
      v-model="model"
      :v="validator"
      :id="id"
      :placeholder="translate(placeholder)"
    />

    <p
      class="label--light margin__t--6"
      v-if="translate(attributes.text)"
    >
      {{ translate(attributes.text) }}
    </p>
  </div>
</template>

<script setup>
import { inject } from 'vue'
import { useModule } from '@/composables/app/useModule'
import { useProcedureBlockValidator } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'

import InputTextarea from '&/atoms/InputTextarea'

const { block } = defineProps({
  block: { type: Object, required: true }
})

const procedure_execution = inject('procedure_execution')

const { translate } = useI18n()
const { label, placeholder, model, id, attributes } = useModule({ component: block, parent: procedure_execution })
const { validator } = useProcedureBlockValidator({ validations: block.mandatory, state: model })
</script>
